exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setmeal-radio[data-v-0163717c]{width:100%;padding-bottom:5px}.setmeal-radio .el-radio[data-v-0163717c]{width:100%;text-align:left}\n", ""]);

// exports
